export const UPLOAD_BATCH_LIST_REQUEST = 'UPLOAD_BATCH_LIST_REQUEST';
export const UPLOAD_BATCH_LIST_SUCCESS = 'UPLOAD_BATCH_LIST_SUCCESS';
export const UPLOAD_BATCH_LIST_FAIL = 'UPLOAD_BATCH_LIST_FAIL';

export const UPLOAD_BATCH_LIST_BY_IDS_REQUEST = 'UPLOAD_BATCH_LIST_BY_IDS_REQUEST';
export const UPLOAD_BATCH_LIST_BY_IDS_SUCCESS = 'UPLOAD_BATCH_LIST_BY_IDS_SUCCESS';
export const UPLOAD_BATCH_LIST_BY_IDS_FAIL = 'UPLOAD_BATCH_LIST_BY_IDS_FAIL';

export const UPLOAD_BATCH_DETAILS_REQUEST = 'UPLOAD_BATCH_DETAILS_REQUEST';
export const UPLOAD_BATCH_DETAILS_SUCCESS = 'UPLOAD_BATCH_DETAILS_SUCCESS';
export const UPLOAD_BATCH_DETAILS_FAIL = 'UPLOAD_BATCH_DETAILS_FAIL';
export const UPLOAD_BATCH_DETAILS_RESET = 'UPLOAD_BATCH_DETAILS_RESET';

export const UPLOAD_BATCH_CREATE_REQUEST = 'UPLOAD_BATCH_CREATE_REQUEST';
export const UPLOAD_BATCH_CREATE_SUCCESS = 'UPLOAD_BATCH_CREATE_SUCCESS';
export const UPLOAD_BATCH_CREATE_FAIL = 'UPLOAD_BATCH_CREATE_FAIL';
export const UPLOAD_BATCH_CREATE_RESET = 'UPLOAD_BATCH_CREATE_RESET';

export const UPLOAD_BATCH_UPDATE_REQUEST = 'UPLOAD_BATCH_UPDATE_REQUEST';
export const UPLOAD_BATCH_UPDATE_SUCCESS = 'UPLOAD_BATCH_UPDATE_SUCCESS';
export const UPLOAD_BATCH_UPDATE_FAIL = 'UPLOAD_BATCH_UPDATE_FAIL';
export const UPLOAD_BATCH_UPDATE_RESET = 'UPLOAD_BATCH_UPDATE_RESET';

export const UPLOAD_BATCH_DELETE_REQUEST = 'UPLOAD_BATCH_DELETE_REQUEST';
export const UPLOAD_BATCH_DELETE_SUCCESS = 'UPLOAD_BATCH_DELETE_SUCCESS';
export const UPLOAD_BATCH_DELETE_FAIL = 'UPLOAD_BATCH_DELETE_FAIL';
export const UPLOAD_BATCH_DELETE_RESET = 'UPLOAD_BATCH_DELETE_RESET';

export const UPLOAD_BATCH_DTO_REQUEST = 'UPLOAD_BATCH_DTO_REQUEST';
export const UPLOAD_BATCH_DTO_SUCCESS = 'UPLOAD_BATCH_DTO_SUCCESS';
export const UPLOAD_BATCH_DTO_FAIL = 'UPLOAD_BATCH_DTO_FAIL';
export const UPLOAD_BATCH_DTO_RESET = 'UPLOAD_BATCH_DTO_RESET';

// Custom action constants for UploadBatch specific functionality
export const UPLOAD_BATCH_BY_ORGANISATION_REQUEST = 'UPLOAD_BATCH_BY_ORGANISATION_REQUEST';
export const UPLOAD_BATCH_BY_ORGANISATION_SUCCESS = 'UPLOAD_BATCH_BY_ORGANISATION_SUCCESS';
export const UPLOAD_BATCH_BY_ORGANISATION_FAIL = 'UPLOAD_BATCH_BY_ORGANISATION_FAIL';

export const UPLOAD_BATCH_BY_PATIENT_REQUEST = 'UPLOAD_BATCH_BY_PATIENT_REQUEST';
export const UPLOAD_BATCH_BY_PATIENT_SUCCESS = 'UPLOAD_BATCH_BY_PATIENT_SUCCESS';
export const UPLOAD_BATCH_BY_PATIENT_FAIL = 'UPLOAD_BATCH_BY_PATIENT_FAIL';

export const UPLOAD_BATCH_BY_STATUS_REQUEST = 'UPLOAD_BATCH_BY_STATUS_REQUEST';
export const UPLOAD_BATCH_BY_STATUS_SUCCESS = 'UPLOAD_BATCH_BY_STATUS_SUCCESS';
export const UPLOAD_BATCH_BY_STATUS_FAIL = 'UPLOAD_BATCH_BY_STATUS_FAIL';

export const UPLOAD_BATCH_BY_FILEPATH_REQUEST = 'UPLOAD_BATCH_BY_FILEPATH_REQUEST';
export const UPLOAD_BATCH_BY_FILEPATH_SUCCESS = 'UPLOAD_BATCH_BY_FILEPATH_SUCCESS';
export const UPLOAD_BATCH_BY_FILEPATH_FAIL = 'UPLOAD_BATCH_BY_FILEPATH_FAIL';

// Upload Batch Relationships paginated endpoints
export const UPLOAD_BATCH_PROCESSING_JOBS_REQUEST = 'UPLOAD_BATCH_PROCESSING_JOBS_REQUEST';
export const UPLOAD_BATCH_PROCESSING_JOBS_SUCCESS = 'UPLOAD_BATCH_PROCESSING_JOBS_SUCCESS';
export const UPLOAD_BATCH_PROCESSING_JOBS_FAIL = 'UPLOAD_BATCH_PROCESSING_JOBS_FAIL';

export const UPLOAD_BATCH_SUBJECTS_REQUEST = 'UPLOAD_BATCH_SUBJECTS_REQUEST';
export const UPLOAD_BATCH_SUBJECTS_SUCCESS = 'UPLOAD_BATCH_SUBJECTS_SUCCESS';
export const UPLOAD_BATCH_SUBJECTS_FAIL = 'UPLOAD_BATCH_SUBJECTS_FAIL';

export const UPLOAD_BATCH_SEND_BATCH_REQUEST = 'UPLOAD_BATCH_SEND_BATCH_REQUEST';
export const UPLOAD_BATCH_SEND_BATCH_SUCCESS = 'UPLOAD_BATCH_SEND_BATCH_SUCCESS';
export const UPLOAD_BATCH_SEND_BATCH_FAIL = 'UPLOAD_BATCH_SEND_BATCH_FAIL';
export const UPLOAD_BATCH_SEND_BATCH_RESET = 'UPLOAD_BATCH_SEND_BATCH_RESET'; 